module.exports = __webpack_public_path__ + "img/dot_menu.e9f04060.png";